import Swal from 'sweetalert2'

const capitalizeFirstLetter = str =>
  str.charAt(0).toUpperCase() + str.slice(1)

export function showAlert (options = { }) {
  const {
    message, icon = 'warning'
  } = options

  const isTimed = icon === 'success'

  const Toast = Swal.mixin({
    position: 'top',
    toast: true,
    showConfirmButton: false,
    showCloseButton: true,
    timerProgressBar: true,
    ...(isTimed && {
      timer: 5000,
      timerProgressBar: true
    }),
    customClass: {
      popup: 'w-[600px] bg-white shadow-md border border-gray-200 text-sm rounded-lg p-4',
      closeButton: 'text-gray-400 hover:text-black text-lg'

    },
    didOpen: toast => {
      toast.onmouseenter = Swal.stopTimer
      toast.onmouseleave = Swal.resumeTimer
    }
  })

  Toast.fire({
    html: message,
    icon,
    title: options.title || capitalizeFirstLetter(icon) + '!',
    ...options
  })
}
